export default __webpack_public_path__ + "static/media/selfie.4e4bd805.jpg";